.svg {
  width: 100%;
  height: 100%;
}
.line {
  stroke-width: 10px;
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke-dasharray: 350;
  will-change: auto;
  transition: stroke-dashoffset 300ms ease-in-out;
}
